import { render, staticRenderFns } from "./CategoryChooser.vue?vue&type=template&id=e3e168ac&scoped=true&"
import script from "./CategoryChooser.vue?vue&type=script&lang=js&"
export * from "./CategoryChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e168ac",
  null
  
)

export default component.exports